export default __webpack_public_path__ + "static/media/TravelBuddy.ea7eca33.png";